import { GET_EVENTS_BUSINESS_NONPROFIT_HOME } from './home.types';

export const getEventBusinessNonProfit = (params) => {
    return {
        type: GET_EVENTS_BUSINESS_NONPROFIT_HOME,
        payload: { params },
    };
};
